import styles from "./index.module.scss";

interface BlockLoaderProps {
  isLoading: boolean;
}
const BlockLoader = ({isLoading}: BlockLoaderProps) => {
  return (
    <div className={styles.loaderContainer}>
      {isLoading && <div className={styles.loader} />}
    </div>
  );
};
export default BlockLoader;